import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import MODALS from 'constants/layout/modals'
import { Note } from 'components/misc'

export default class InfoSMARTModal extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <MaterialModal.Body
        id={MODALS.INFO_SMART_MODAL}
        narrow noHeader
      >
        <MaterialModal.Content noFooter noHeader>
          <Note intlKey='label.s_specific'>
            <b>S-Specific: Your Goal shouldn't be too broad.</b> Instead of setting; ‘I want to be better at violin’, you could say, ‘I would like to master F scale in playing the violin’.
          </Note>
          <Note intlKey='label.m_measurable'>
            <b>M-Measurable: You should be able to tell when you have completed your goal.</b> Instead of setting your goals as ‘I want to help the community’, you could say, ‘I want to help out the people who visit soup kitchens by volunteering once a week’. This way the goal can be tested.
          </Note>
          <Note intlKey='label.a_achievable'>
            <b>A-Achievable: Your Goal should be something you can achieve in your specific Award time frame.</b> Rather than saying ‘I want to end poverty’, it would be best to set a more practical goal such as ‘I would like to raise funds to send overseas to help alleviate poverty in a third world village.’
          </Note>
          <Note intlKey='label.r_realistic'>
            <b>R-Realistic: This is basically the same as ‘Achievable’.</b> Is it ‘Realistic’ that you can achieve your goals in that time frame?
          </Note>
          <Note intlKey='label.t_timely'>
            <b>T-Timely: Your goal should include when you would like to have the goal completed by.</b> Your Goal could perhaps be, ‘I would like to master the F scale in violin within three months.’
          </Note>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
